import { useState } from "react";
import { type ReloadOptions } from "@inertiajs/core";
import type { SearchParams } from "@/types/job_search/search";

type Args = {
  browsing: boolean;
  currentPage: number;
  lastPublishDate: string | null;
  searchParams: SearchParams;
};

export const useSearchResultsReload = ({
  browsing,
  currentPage,
  lastPublishDate,
  searchParams,
}: Args) => {
  const [loading, setLoading] = useState(false);

  const reloadParams: ReloadOptions = {
    data: {
      ...searchParams,
      ...(!browsing && { page: currentPage + 1 }), // The page number is only relevant when we're not browsing
      ...(browsing && { search_after: lastPublishDate }), // When browsing, we use a "live cursor" instead of page number
    },
    preserveUrl: true,
    only: ["jobPosts", "moreResultsAvailable", "page"],
    onBefore: () => {
      setLoading(true);
    },
    onFinish: () => {
      setLoading(false);
    },
  };

  return { reloadParams, loading };
};

export default useSearchResultsReload;
